import * as React from 'react';
import { connect } from 'react-redux';
import '../../content/Font.scss';
import { ToastMessage } from '../../models/utilities/toast-message';
import { ServiceCenterPicker } from '../../containers/service-center-picker/ServiceCenterPicker';
import { Userbug } from '../../containers/userbug/Userbug';
import { IApplicationState } from '../../store/IApplicationState';
import { Footer } from '../footer/Footer';
import { Header } from '../header/Header';
import { DownloadingPanel } from '../loading/Downloading';
import { LoadingPanel } from '../loading/Loading';
import { Navbar } from '../navbar/Navbar';
import { ToastNotification } from '../notification/ToastNotification';
import { routes } from '../route-table/route-config';

import '../../content/Autocomplete.scss';
import '../../content/Buttons.scss';
import '../../content/Forms.scss';
import '../../content/Icons.scss';
import '../../content/Modal.scss';
import '../../content/Tables.scss';
import '../../content/Utilities.scss';
import './Layout.scss';

import '../../content/Responsive.scss';

import '../../content/IE11.scss';

// #region Component State 

const initialState = {
    isSideNavOpen: false
};

type State = Readonly<typeof initialState>;

// #endregion

// #region Component Props

interface IProps {
    toasts          : ToastMessage[];
    isLoading       : boolean;
    isDownloading   : boolean;
    children        : any[];
}

// #endregion

class LayoutPage extends React.Component<IProps, State> {

    public state : State = initialState;

    public render() {
        return (
            <div>
                { this.props.isLoading ? <LoadingPanel  /> : null }
                { this.props.isDownloading ? <DownloadingPanel /> : null }
                <Header />
                
                {/*
                    The drawer the sidebar is below 1000px wide.  It closes when a link in it is followed, and when the
                    page behind it is pressed.  It is not a click away listener: the listener's own element would be the
                    menu button, and pressing a section in the drawer, to open it, would count as pressing away
                */}
                <label id="offcanvas-toggle-icon" htmlFor="offcanvas-toggle" onClick={this.openSideNav}>
                    <i className="la la-navicon"/>
                </label>
                <input 
                    type="checkbox" 
                    id="offcanvas-toggle" 
                    checked={ this.state.isSideNavOpen }
                    onChange={ () => { return; } }
                    name="offcanvas-toggle" 
                />

                <div className="page-wrap">
                    <div className="container-fluid">
                        {/* <Router> */}
                            <div className="row">
                                <Navbar
                                    routes={ routes }
                                    onNavigate={ this.closeSideNav }
                                    serviceCenter={ <ServiceCenterPicker /> }
                                    account={ <Userbug /> } />
                                <main role="main" className="col-md-9 col-lg-10" onClick={ this.closeSideNav }>
                                    { this.props.children }
                                    <Footer />
                                </main>
                            </div>
                        {/* </Router> */}
                    </div>
                </div>
                {
                    this.props.toasts.map((t: ToastMessage, idx: number) => (
                        <ToastNotification key={idx} toast={t} toastIdx={idx} onDismiss={ this.dismissToast } />
                    ))
                }
            </div>
        );
    }

    private dismissToast = (idx: number) => {
        this.props.toasts.splice(idx, 1);
    }

    private openSideNav = () => {
        const current = this.state.isSideNavOpen;
        this.setState({
            isSideNavOpen: !current
        });
    }

    private closeSideNav = () => {
        if (this.state.isSideNavOpen) {
            this.setState({
                isSideNavOpen: false
            });
        }
    }
}

const mapStateToProps = (state: IApplicationState) => {
    return {
        toasts: state.utility.toasts,
        isLoading: state.utility.isLoading,
        isDownloading: state.utility.isDownloading
    };
};

const ConectedLayoutPage = connect(
    mapStateToProps,
    {}
)(LayoutPage);

export { ConectedLayoutPage };
